import React, { useState, useEffect } from "react";
import "../AddClients/tableStyle.css";
import {
  getclientslist,
  getAllDoByClient,
  getDeliveryOrderDetailsById,
} from "../../Services/Services";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Button, Form, Select, Input } from "antd";
import { FaPrint, FaFileExcel } from "react-icons/fa";
import Header from "../Header-Footer/Header";
import * as XLSX from "xlsx";
import Footer from "../Header-Footer/Footer";

export default function AllOrder() {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [allData, setAllData] = useState([]);
  const [doDetails, setdoDetails] = useState([]);
  const [clientList, setclientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedDo, setSelectedDo] = useState(null);
  const [doList, setdoList] = useState([]); // State for start date filter
  const [date, setDate] = useState("");
  const componentRef = useRef();
  const [form] = Form.useForm();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    Getclientslist();
  }, []);

  const Getclientslist = async () => {
    const response = await getclientslist();
    if (response) {
      const filterparty = response.client_list.filter(
        (o) => o.com_name === localStorage.getItem("com_name")
      );
      setclientList(filterparty);
    }
  };

  const Get_Do_Details = async (client_id) => {
    setSelectedClient(client_id);
    setSelectedDo(null);
    setdoList([]);
    setDeliveryOrder([]);
    setdoDetails([]);

    form.setFieldsValue({ do_id: undefined }); // DO field form clear

    const response = await getAllDoByClient({
      com_name: localStorage.getItem("com_name"),
      client_id,
    });
    if (response) setdoList(response);
  };

  const GetDeliveryOrderDetails = async (do_id) => {
    setSelectedDo(do_id); // DO select update
    const response = await getDeliveryOrderDetailsById(do_id);
    if (response) {
      setDeliveryOrder(response.order_list);
      setdoDetails(response.do_details);
    }
  };

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = deliveryOrder.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.truck_owner_name,
      e.pan_no,
      e.vehicle_no,
      e.dispatch_quantity,
      e.received_quantity,
      e.freight_quantity,
      e.sort_quantity,
      e.moisture_received_per,
      e.actual_quantity,
      e.moisture_deduct_quantity,
      e.moisture_amount,
      e.moisture_deduct,
      e.sort_amount,
      e.freight_rate,
      e.freight_amount,
      e.tds_per,
      e.tds,
      e.advance,
      e.commision,
      e.pay_amount,
      e.date,
      // Add other fields here based on your table structure
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "Sr. No",
        "Party Name",
        "DO Number",
        "Truck Owner Name",
        "Pan No",
        "Vehicle No",
        "Dipatch Qty",
        "Recieved Qty",
        "Freight Qty",
        "Sort Qty",
        "Moisture",
        "Actual Qty",
        "Moisture Deduct Qty",
        "Moisture Amt",
        "Moisture Deduct",
        "Sort Amount",
        "Freight Rate",
        "Freight Amt",
        "Tds %",
        "Tds Amt",
        "Advance Amt",
        "Commision Amt",
        "Pay Amt",
        "Received Date",
        // Add other headers here based on your table structure
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "DeliveryOrderDetails");

    XLSX.writeFile(workbook, "Do Order List.xlsx");
  };
  useEffect(() => {
    setDeliveryOrder(
      allData.filter((res) =>
        res.received_date.toLowerCase().includes(date.toLowerCase())
      )
    );
  }, [date]);
  const formateDate = (date) => {
    if (date) {
      const [year, month, day] = date.split("-");
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
    }
  };

  return (
    <div style={{ height: "90vh" }}>
      <Header heading="ORDER FREIGHT VIEW" />
      <Form layout="vertical" form={form}>
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-4 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
          <Form.Item
            name="client_id"
            label={<b>Select Party Name</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Select
              value={selectedClient}
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              onChange={Get_Do_Details}
            >
              {" "}
              {clientList.map((e) => (
                <Select.Option value={e.client_id}>
                  {e.client_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="do_id"
            label={<b>Select DO No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Select
              value={selectedDo}
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              onChange={GetDeliveryOrderDetails}
              options={doList.map((d) => ({ label: d.do_no, value: d.id }))}
            />
            {/* {doList.map((do_i) => (
                                <Select.Option value={do_i.id}>
                                    {do_i.do_no}
                                </Select.Option>
                            ))} */}
          </Form.Item>
          <Form.Item
            name="search_date"
            label={<b>Seaech Received Date</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input
              placeholder="Search by Receive Date."
              value={date}
              type="date"
              onChange={(e) => setDate(e.target.value)}
            />
          </Form.Item>

          <Form.Item>
            <br></br>

            <Button
              onClick={handlePrint}
              style={{ backgroundColor: "black", color: "white", top: "10px" }}
            >
              <FaPrint />
            </Button>
            <Button
              onClick={handleExportToExcel}
              style={{
                backgroundColor: "green",
                color: "white",
                marginLeft: "10px",
                top: "10px",
              }}
            >
              <FaFileExcel />
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div className="table-wrapper" ref={componentRef}>
        <table id="my-table" className="w-full">
          {[doDetails].map((e) => (
            <thead id="table_border">
              <tr>
                <td colSpan={1} id="table_data"></td>
                <td colSpan={5} id="table_data">
                  <b>Do Number : {e.do_no}</b>
                </td>
                <td colSpan={5} id="table_data">
                  <b>Total Quantity : {e.quantity}</b>
                </td>
                <td colSpan={5} id="table_data">
                  <b>Total Freight Amount: {e.paid_amt}</b>
                </td>
              </tr>
              <tr>
                <td colSpan={1} id="table_data"></td>
                <td colSpan={5} id="table_data">
                  <b>Do Start Date : {formateDate(e.do_start_date)}</b>
                </td>
                <td colSpan={5} id="table_data">
                  <b>
                    Dispatch Qty :
                    {deliveryOrder
                      .reduce(
                        (accumulator, currentValue) =>
                          accumulator + +currentValue.dispatch_quantity,
                        0
                      )
                      .toFixed(3)}
                  </b>
                </td>
                <td colSpan={5} id="table_data">
                  <b>Credit Amount : {e.advance_amt}</b>
                </td>
              </tr>
              <tr>
                <td colSpan={1} id="table_data"></td>
                <td colSpan={5} id="table_data">
                  <b>Do End Date : {formateDate(e.do_end_date)}</b>
                </td>

                <td colSpan={5} id="table_data">
                  <b>
                    Rec Qty :
                    {deliveryOrder
                      .reduce(
                        (accumulator, currentValue) =>
                          accumulator + +currentValue.received_quantity,
                        0
                      )
                      .toFixed(3)}
                  </b>
                </td>

                <td colSpan={5} id="table_data">
                  <b>Debit Amount : {e.total_advance_paid}</b>
                </td>
              </tr>
              <tr>
                <td colSpan={1} id="table_data"></td>
              </tr>
              <tr>
                <td colSpan={1} id="table_data"></td>
              </tr>
              <tr>
                <td colSpan={1} id="table_data"></td>
                <td colSpan={5} id="table_data">
                  <b>Party Name : {e.client_name}</b>
                </td>
                <td colSpan={5} id="table_data">
                  {/* <b>
                    Balance Qty :
                    {(
                      parseFloat(e.quantity) -
                      parseFloat(
                        deliveryOrder
                          .reduce(
                            (accumulator, currentValue) =>
                              accumulator + +currentValue.dispatch_quantity,
                            0
                          )
                          .toFixed(3)
                      )
                    ).toFixed(3)}
                  </b> */}
                </td>
                <td colSpan={5} id="table_data">
                  <b>Contact Number : {e.contact_no}</b>
                </td>
              </tr>
            </thead>
          ))}
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Id
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Truck Owner Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Pan No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Vehicle No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Dipatch Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Recieved Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Freight Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sort Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Moisture %
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Actual Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Moisture Deduct Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Moisture Amt
              </th>

              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Moisture Deduct
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sort Amount
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Freight Rate
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Freight Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Tds %
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Tds Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Advance Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Commision Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Pay Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Dispatch Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Received Date
              </th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr key={e.client_id}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.id}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.truck_owner_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.pan_no}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.vehicle_no}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.dispatch_quantity.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.received_quantity.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.freight_quantity.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.sort_quantity}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.moisture_received_per}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.actual_quantity}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.moisture_deduct_quantity}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.moisture_amount}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.moisture_deduct}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.sort_amount}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.freight_rate}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.freight_amount}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.tds_per}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.tds}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.advance}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.commision}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.pay_amount}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.received_date)}
                </td>
              </tr>
            ))}
            <tr style={{ backgroundColor: "#e9e9e9" }}>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={5}
              >
                <b>Total</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.dispatch_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.received_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_deduct,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.sort_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.tds,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.advance,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.commision,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.pay_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={2}
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
